// Material UI
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

// Utilities
import brands from "../../../Utilities/Brands";

const SelfOptOutSearchForm = (
  brandId,
  setBrandId,
  email,
  setEmail,
  reportToken,
  setReportToken,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  ipAddress,
  setIpAddress,
  createdStartDate,
  setCreatedStartDate,
  createdEndDate,
  setCreatedEndDate,
  approvedStatusId,
  setApprovedStatusId,
  showOnlyVerified, 
  setShowOnlyVerified
) => {
  const formLabels = [
    {
      Label: "Email",
      Element: "TextField",
      Value: email,
      Setter: setEmail,
    },
    {
      Label: "Brand ID",
      Element: "FormControl",
      Value: brandId,
      Setter: setBrandId,
      Data: <>
      <option value="" key="-1" />
        {brands.map((card, _idx) => {
          return (
            <option key={card._id} value={card._id}>
              {card.brand}
            </option>
          );
        })}
    </>
    },
    {
      Label: "Report Token",
      Element: "TextField",
      Value: reportToken,
      Setter: setReportToken,
    },
    {
      Label: "First Name",
      Element: "TextField",
      Value: firstName,
      Setter: setFirstName,
    },
    {
      Label: "Last Name",
      Element: "TextField",
      Value: lastName,
      Setter: setLastName,
    },
    {
      Label: "IP Address",
      Element: "TextField",
      Value: ipAddress,
      Setter: setIpAddress,
    },
    {
      Label: "Created Start Date",
      Element: "TextField",
      Type: "date",
      Value: createdStartDate,
      Setter: setCreatedStartDate,
    },
    {
      Label: "Created End Date",
      Element: "TextField",
      Type: "date",
      Value: createdEndDate,
      Setter: setCreatedEndDate,
    },
    {
      Label: "Approved Status",
      Element: "FormControl",
      Value: approvedStatusId,
      Setter: setApprovedStatusId,
      Data: <>
        <option value="-1" key="-1">All</option>
        {[{status: "Pending", _id: 0}, {status: "Approved", _id: 1}, {status: "Ignored", _id: 2}, {status: "Auto Ignored", _id: 3}, {status: "Auto Approved", _id: 4}, {status: "Pending + Auto Ignored", _id: 30}]
        .map((card, _idx) => {
          return (
            <option key={_idx+1} value={card._id}>
              {card.status}
            </option>
          );
        })}
    </>
    },
    {
      Label: "Show Only Verified",
      Element: "Checkbox",
      Value: showOnlyVerified,
      Setter: setShowOnlyVerified,
    },
  ];

  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              key={idx}
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            />
          );
        case "FormControl":
          return (
            <FormControl
              key={idx}
              variant="outlined"
              style={{ margin: 8, width: "14rem" }}
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                {Label}
              </InputLabel>
              <Select
                native={true}
                label={Label}
                value={Value}
                inputProps={{
                  name: `${Label.toLowerCase()}`,
                  id: `outlined-${Label.toLowerCase()}-native-simple`,
                }}
              >
                {Data}
              </Select>
            </FormControl>
          );
        case "Checkbox":
          return (
            <FormGroup 
              key={idx}>
              <FormControlLabel
                control={<Checkbox key={idx} checked={Value} onChange={(e) => Setter(e.target.checked)} />}
                label={Label}
                style={{ margin: 5, width: "15rem", color: '#accfe6' }}
              />
            </FormGroup>
          );
        default:
          return null;
      }
    }
  );
};

export default SelfOptOutSearchForm;
